import { Drawer } from "rsuite"
export const SBADrawer = (props) => {
    const { open, backdrop, setOpen, children, title, close ,size ,closeButton, HeaderClassName,...additional} = props;
    return <>
        <Drawer open={open} backdrop={backdrop} size={size?size :'md'} onClose={() => setOpen(false)} {...additional} containerStyle={{height:'100%'}}>
            <Drawer.Header className={HeaderClassName} closeButton={closeButton==undefined || closeButton==true }>
                <Drawer.Title>{title}</Drawer.Title>
                {close && <Drawer.Actions>
                    <button onClick={() => setOpen(false)}>Cancel</button>
                </Drawer.Actions>}
            </Drawer.Header>
            <Drawer.Body>
                {children}
            </Drawer.Body>
        </Drawer>
    </>
}